/* Mery You Stone - Barra Envío Gratis */
(function() {
  'use strict';
  
  const CONFIG = {
    threshold: 50,
    currency: '€',
    debug: false
  };
  
  function log(msg) {
    if (CONFIG.debug) console.log('[MYS Shipping Bar]', msg);
  }
  
  function initShippingBar() {
    const bar = document.getElementById('shippingBarMYS');
    if (!bar) {
      log('ERROR: No se encontró el elemento #shippingBarMYS');
      return;
    }
    
    bar.style.display = 'flex';
    document.body.classList.add('has-shipping-bar-mys');
    
    updateBar();
    
    document.addEventListener('cart:updated', updateBar);
    
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('button[type="submit"][name="add"]');
      if (btn) {
        setTimeout(updateBar, 1000);
      }
    });
    
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.scrollY;
      if (currentScroll > 150 && currentScroll > lastScroll) {
        bar.classList.add('hidden-mys');
      } else {
        bar.classList.remove('hidden-mys');
      }
      lastScroll = currentScroll;
    }, { passive: true });
    
    log('Barra inicializada correctamente');
  }
  
  async function updateBar() {
    const bar = document.getElementById('shippingBarMYS');
    const fill = document.getElementById('progressFillMYS');
    const message = document.getElementById('shippingMessageMYS');
    
    if (!bar || !fill || !message) {
      log('ERROR: Elementos no encontrados');
      return;
    }
    
    let cartTotal = 0;
    
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const cart = await response.json();
      cartTotal = cart.total_price / 100;
      log('Cart total: ' + cartTotal + '€');
    } catch (error) {
      log('No se pudo obtener el carrito: ' + error.message);
    }
    
    const remaining = Math.max(0, CONFIG.threshold - cartTotal);
    const progress = Math.min((cartTotal / CONFIG.threshold) * 100, 100);
    
    fill.style.width = progress + '%';
    
    if (cartTotal >= CONFIG.threshold) {
      message.innerHTML = '<span class="icon-mys">🎉</span> <strong>¡Envío GRATIS desbloqueado!</strong>';
      bar.classList.add('unlocked-mys');
    } else if (remaining <= 10) {
      message.innerHTML = `<span class="icon-mys">✨</span> ¡Solo <strong>${remaining.toFixed(2)}${CONFIG.currency}</strong> para envío gratis!`;
      bar.classList.remove('unlocked-mys');
    } else {
      message.innerHTML = `<span class="icon-mys">🚚</span> Añade <strong>${remaining.toFixed(2)}${CONFIG.currency}</strong> para envío gratis`;
      bar.classList.remove('unlocked-mys');
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingBar);
  } else {
    initShippingBar();
  }
  
  setTimeout(function() {
    const bar = document.getElementById('shippingBarMYS');
    if (bar && bar.style.display === 'none') {
      log('Reintentando inicialización...');
      initShippingBar();
    }
  }, 2000);
  
})();